import { useTitle } from "@vueuse/core";
import { storeToRefs } from "pinia";
import {
  type RouteLocationNormalizedLoaded,
  type RouteRecordNormalized,
  useRoute,
} from "vue-router";

import { getLocaleText } from "shared/boot/i18n";
import { useGlobalStore } from "shared/stores/global";

function getTitle(
  matched: RouteRecordNormalized,
  route: RouteLocationNormalizedLoaded
): string {
  const { title } = matched.meta;

  if (typeof title === "function") {
    return title(route) || "";
  }

  return typeof title === "string" ? title : "";
}

// Keeps `document.title` in sync with the deepest matched route that has `meta.title`
export function useDocumentTitle(): void {
  const route = useRoute();
  const { appConfig } = storeToRefs(useGlobalStore());

  useTitle(() => {
    const { platformName } = appConfig.value;

    const pageTitle = Array.from(route.matched)
      .reverse()
      .map((matched) => getTitle(matched, route))
      .find(Boolean);

    return pageTitle
      ? getLocaleText("routes.document_title", {
          app: platformName,
          page: pageTitle,
        })
      : platformName;
  });
}

export default useDocumentTitle;
